<template>
  <v-alert
    prominent
    text
    dense
    type="info"
    class="py-1 w-100"
    icon="fas fa-exclamation-triangle"
  >
    <ERow align="center">
      <ECol class="py-0">
        <span class="subtitle-1">This will restore the camera.</span>
      </ECol>
      <ECol class="shrink pl-0">
        <v-btn color="primary" small @click="restoreCamera"
          >Restore Camera</v-btn
        >
      </ECol>
    </ERow>
  </v-alert>
</template>

<script>
import { mapStores } from "pinia"
import { useCameraDialogStore } from "@/stores/cameraDialog"
import { useKitSummaryStore } from "@/stores/kitSummary"

export default {
  name: "RestoreCamera",
  computed: {
    ...mapStores(useCameraDialogStore, useKitSummaryStore),
  },
  methods: {
    async restoreCamera() {
      if (
        await this.$confirmDialog.open({
          title: "Are you sure ?",
          message: "This will restore camera.",
        })
      ) {
        await this.cameraDialogStore.restoreCamera()
        await this.kitSummaryStore.loadKit(this.cameraDialogStore.camera.kitId)
      }
    },
  },
}
</script>
